module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_resort_sola-0ccdeaff6625ccd9ea670dac9d63205d.webp";